export default function (loan) {
  if (loan.status === 'approved' && loan.fundingAmountRemaining > 0) {
    return 'open'
  }

  if (
    loan.status === 'funded' ||
    loan.status === 'repaying' ||
    (loan.status === 'approved' && loan.fundingAmountRemaining === 0)
  ) {
    return 'funded'
  }

  if (loan.status === 'finished') {
    return 'finished'
  }

  if (loan.status === 'devalued') {
    return 'devalued'
  }

  if (loan.status === 'defaulted') {
    return 'defaulted'
  }
}
